import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 14 Feb 2026 3:46 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.t_s6tqNTkdzbSoIVswtyZ-Z0V59DG7S85YTFdPIZlIwglNPrNgtPsUBMo-FzWXo6GFdZVJulAAf4r4F31qM1CMe23yDh6iaDvvzbWXeCMPPy6BmtjFqn1RM96uZPkiFPaAT42wgi8lewR8EUIokCQXqtZ-bQbJEHxulUdPoAAttDMHq0tvXeGWSICQZHmV3mJdzF-zmvgrAfiqaN_G_Q_jOGKdal9DJFNRqDvehUstGL4-UxctxIbdshuEz0A7LjpA-MZyUzbaS8MqrJy8vzuRZvvB9E7ksynPYqgKf9pkyN5_pg4U2qyoR73z-BSQRucJDiVtOdeW4Q1M5J-aPcch_ENlE2dCgJRA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-02-21T02:47:11.508459Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-02-14T02:47:02+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.t_s6tqNTkdzbSoIVswtyZ-Z0V59DG7S85YTFdPIZlIwglNPrNgtPsUBMo-FzWXo6GFdZVJulAAf4r4F31qM1CMe23yDh6iaDvvzbWXeCMPPy6BmtjFqn1RM96uZPkiFPaAT42wgi8lewR8EUIokCQXqtZ-bQbJEHxulUdPoAAttDMHq0tvXeGWSICQZHmV3mJdzF-zmvgrAfiqaN_G_Q_jOGKdal9DJFNRqDvehUstGL4-UxctxIbdshuEz0A7LjpA-MZyUzbaS8MqrJy8vzuRZvvB9E7ksynPYqgKf9pkyN5_pg4U2qyoR73z-BSQRucJDiVtOdeW4Q1M5J-aPcch_ENlE2dCgJRA'

// {
//   "access_token": "v2.local.szhXmVKHoGC9ZGvQVbKIrl6yQcJXvIndCQxHIwwz-IHnJ1ghdT1wxePeZftSUjJEJGC1KX6IZMf4DfJ-GBV8gWPO_sJzwVSGUD3XiTvaIGl-xV7ds6qMtg_m6tI0Pxl4i8SJynxRD2g0IFGEGS9fGElbTZukcGTbuXmo0QIv4iiZkoFL4OJA81mTg60hhghn492J_PXmcIycBLsr491xKu_q8kzgbUSJ9sA7mdnCVuNsL1H04SQPW6lkCx3xf8dnN94YnBkvQPNhPh89HmSnbLxJa0rjov6KOwoKEaD_bl0y8GvhUC68SybdgZJ0LbOwpQBVrZx2RPRGeh3apCWY_q12CkbM",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-02-21T02:48:45.165582Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-02-14T02:48:33+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.szhXmVKHoGC9ZGvQVbKIrl6yQcJXvIndCQxHIwwz-IHnJ1ghdT1wxePeZftSUjJEJGC1KX6IZMf4DfJ-GBV8gWPO_sJzwVSGUD3XiTvaIGl-xV7ds6qMtg_m6tI0Pxl4i8SJynxRD2g0IFGEGS9fGElbTZukcGTbuXmo0QIv4iiZkoFL4OJA81mTg60hhghn492J_PXmcIycBLsr491xKu_q8kzgbUSJ9sA7mdnCVuNsL1H04SQPW6lkCx3xf8dnN94YnBkvQPNhPh89HmSnbLxJa0rjov6KOwoKEaD_bl0y8GvhUC68SybdgZJ0LbOwpQBVrZx2RPRGeh3apCWY_q12CkbM'

// {
//   "access_token": "v2.local.QuHEpp8ejpaU_sTBEiFXM8A5MmHEiVEGPB94fMdTdfhbRgCtNLqJgq9dJpEMyIor4Y5k6o-HXDgXtAS9ILvXdd6k7FU7aBm_bjbbsLNX-NKY-JYnYDCjAmPaxx73AII-ndkBJFqetGF8OAn9bS2NjEGrEEwhqyaf-nTWn2IqsF4_7J96a-7LVyF3NuNmy_hhLW4Ch8FHbYYNcho1NzF6MsJc9gEfhEJUEL-Uo7QNxPZ65cvaorklaXlFhULMX_1sMnpuCrmjrPiUEHP0jl_v-zsidgGJEn93ALnDt2G-4g78-6UPElY1696rg2G-qiuV01BjxnJ6KxB3VFJdJYQiVyUWM7E",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-02-21T02:49:57.379891Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.QuHEpp8ejpaU_sTBEiFXM8A5MmHEiVEGPB94fMdTdfhbRgCtNLqJgq9dJpEMyIor4Y5k6o-HXDgXtAS9ILvXdd6k7FU7aBm_bjbbsLNX-NKY-JYnYDCjAmPaxx73AII-ndkBJFqetGF8OAn9bS2NjEGrEEwhqyaf-nTWn2IqsF4_7J96a-7LVyF3NuNmy_hhLW4Ch8FHbYYNcho1NzF6MsJc9gEfhEJUEL-Uo7QNxPZ65cvaorklaXlFhULMX_1sMnpuCrmjrPiUEHP0jl_v-zsidgGJEn93ALnDt2G-4g78-6UPElY1696rg2G-qiuV01BjxnJ6KxB3VFJdJYQiVyUWM7E'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
